module.exports = __webpack_public_path__ + "img/skills_vue.d1d21e29.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/skills_vue.svg
// module id = v5ga
// module chunks = 1